import { h } from 'preact'

const SliderRightIcon = ({ size = 32 }: { size?: number }) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
    <path d="M24.48 17.568l-13.76 13.792c-0.896 0.864-2.304 0.864-3.168 0-0.896-0.896-0.896-2.304 0-3.168l12.16-12.192-12.16-12.192c-0.896-0.864-0.896-2.272 0-3.168 0.864-0.864 2.272-0.864 3.168 0l13.76 13.76c0.416 0.448 0.64 1.024 0.64 1.6s-0.224 1.152-0.64 1.568z" />
  </svg>
)

export default SliderRightIcon
